var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[(this.$store.state.user)?_c('router-view'):_vm._e(),_c('Notification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }